module.exports = __webpack_public_path__ + "img/box-before.d72a781a.svg";